import { useState } from 'react'
import { ConcreteMixDesignFormItemProps, ConcreteMixDesignItem } from './types'
import { useConcreteNotificationsContext } from '../../../../../../ConcreteNotificationsContext'
import { LabeledValueType } from 'components/CIMSSelect/types'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../../../../../../components/GroupFallback'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { alphabeticalSort } from '@cims-online/shared'

const ConcreteMixDesignFormItem: React.FC<ConcreteMixDesignFormItemProps> = ({
  onChange,
  value,
}) => {
  const { data } = useConcreteNotificationsContext()
  const [values, setValues] = useState<Map<string, ConcreteMixDesignItem>>(
    (value ?? []).reduce(
      (map, v) => map.set(v.concreteMixDesignId, v),
      new Map<string, ConcreteMixDesignItem>()
    )
  )
  const change = (id: string, recipients: LabeledValueType[]) =>
    setValues((prev) => {
      const map = new Map(prev)
      map.set(id, { concreteMixDesignId: id, recipients })
      onChange?.([...map.values()])
      return map
    })

  return (
    <CIMSCollapse
      noPanelsContent={<GroupFallback group="Concrete Mix Designs" />}
      panels={data.concreteMixDesigns
        .sort(alphabeticalSort('mixDesignNumber'))
        .map(({ globalId, mixDesignNumber }) => {
          return {
            key: globalId,
            header: mixDesignNumber ?? '',
            children: (
              <CIMSFormItem label="Recipients">
                <RecipientsSelect
                  value={values.get(globalId)?.recipients ?? []}
                  onChange={(recipients) =>
                    change(globalId, recipients as LabeledValueType[])
                  }
                />
              </CIMSFormItem>
            ),
          }
        })}
    />
  )
}

export default ConcreteMixDesignFormItem
